<template>
  <div
    class="d-md-flex flex-column flex-lg-row justify-content-between mt-3 mb-3"
  >
    <div class="w-100">
      <!-- Extra info buttons -->
      <div class="extra-info-alt p-0 mb-0 d-flex flex-column">
        <ExtraInfoButtons
          v-if="tourHubItem"
          itemtype="tour"
          :item="tourHubItem"
          :status="status"
        />
        <div class="my-3" v-if="getTravellers || tourHubItem.status">
          <div v-if="getTravellers" class="d-flex flex-column flex-lg-row th-info">
            <div class="col-md-2">
              <h4>Reservation For</h4>
            </div>
            <div class="col-10">
              <p>{{ getTravellers }}</p>
            </div>
          </div>

          <div v-if="tourHubItem.status" class="col-12 col-md-11">
            <hr class="m-0" />
          </div>
          <div v-if="tourHubItem.status" class="d-flex flex-column flex-lg-row th-info">
            <div class="col-md-2">
              <h4 class="h-100">Status</h4>
            </div>
            <div class="col-10">
              <p>{{ tourHubItem.status }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="showTHSpecialOffers"
          class="d-flex flex-column flex-lg-row"
        >
          <div class="col-md-2">
            <h4>Included Offers</h4>
          </div>
          <div class="col-10">
            <span
              v-for="(offer, i) in tourHubItem.specialOffers"
              :key="offer._id"
              class="col-12 w-100 flex-column flex-lg-row"
              >
              <p class="py-0 my-0">
                {{ offer.displayTitle }}
              </p>
              <p
                v-if="
                  offer.bookingDateValidity &&
                  offer.bookingDateValidity.length &&
                  offer.bookingDateValidity[0].type &&
                  offer.bookingDateValidity[0].type !== 'always'
                "
                class="my-0 py-1"
              >
                {{ specialOfferBookingDate(offer.bookingDateValidity[0]) }}
              </p>
              <p v-if="offer.pointOfConfirmation === 'check-in'" class="my-0 py-1">Offer subject to availability at check-in</p>
              <hr v-if="i !== tourHubItem.specialOffers.length - 1" />
            </span>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-lg-3 col-md-12 mt-0"></div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <!-- ///toggle between the two buttons, show or hide itinerary/// -->
            <button
              v-if="showBlackButton && !tourHubItem.priceOnRequest"
              @click="toggleIsVisible('add')"
              class="voucher-btn btn-dark button-width text-center position-relative m-0"
            >
              <i class="text-center material-icons vtd-icon-4 mr-0 my-auto align-self-center"></i>
              <span class="w-100 text-center">
                View your {{ countryContent.tourStyle }} Itinerary
              </span>
            </button>
            <button
              v-if="showBlackButton && tourHubItem.priceOnRequest"
              class="w-100 text-center position-relative m-0 itinerary-pending-notice"
              disabled
            >
              <i class="text-center material-icons vtd-icon-4 mr-0 my-auto align-self-center">schedule</i>
              <span>
                Your itinerary is being worked on and is temporarily unavailable.
              </span>
            </button>
            <button
              v-if="!showBlackButton"
              @click="toggleIsVisible('remove')"
              class="btn-outline-dark border border-dark border-3 button-width text-center position-relative m-0 bg-white text-dark"
            >
              <i class="text-center material-icons vtd-icon-4 mr-0 my-auto align-self-center text-dark"></i>
              <span class="w-100 text-center text-dark">
                Hide {{ countryContent.tourStyle }} Itinerary
              </span>
            </button>
          </div>
          <div class="col-lg-3 col-md-12 mt-4">
            <b-form-select
              v-if="!showBlackButton"
              class="text-center"
              style="height: 45px"
              v-model="viewOptionSelected"
              :options="viewOptions"
              @change="changeView"
            />
          </div>
        </div>
      </div>
    </div>
    <VoucherModal ref="voucherModal" title="Voucher Information" />
  </div>
</template>

<script>
import dayjs, { parseWithWeekday } from '@/lib/dayjs';
import { mapGetters } from "vuex";
import { outputTravellers } from "../utils";
import ExtraInfoButtons from "../extraInfoButtons/index.vue";
import { getSite } from "@/lib/utilities";
import VoucherModal from "../modals/voucher-modal.vue";

export default {
  components: {
    ExtraInfoButtons,
    VoucherModal,
  },
  props: {
    tourHubItem: {
      type: Object,
    },
    forceClosePrivateTour: {
      type: Boolean,
    },
    countryContent: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      startingPoint: "",
      duration: "",
      endPoint: "",
      status: "",
      tourFor: "",
      startDate: "",
      endDate: "",
      showBlackButton: true,
      viewOptionSelected: "summary",
      viewOptions: [
        { value: "summary", text: "Summary" },
        { value: "detailed", text: "Detailed" },
        { value: "printer friendly", text: "Printer Friendly" },
      ],
      serviceTravellers: "",
    };
  },
  computed: {
    ...mapGetters("booking", ["getNamesPlus"]),
    showTHSpecialOffers() {
      let showOffers = false;
        if (this.tourHubItem.specialOffers &&
        this.tourHubItem.specialOffers.length > 0) {
          this.tourHubItem.specialOffers.forEach((offer) => {
            if (offer.displayTitle) {
              showOffers = true;
            }
          });
        }
        return showOffers;
    },
    getTravellers() {
      return this.serviceTravellers;
    },
  },
  watch: {
    forceClosePrivateTour() {
      if (this.forceClosePrivateTour) {
        this.toggleIsVisible("remove", true);
      }
    },
  },
  mounted() {
    // Set values
    this.getStartingPoint();
    this.getDuration();
    this.getEndPoint();
    this.getStatus();
    this.getTourFor();
    this.getStartDate();
    this.getEndDate();
    this.setReservationFor();

  },
  methods: {
    getStartingPoint() {
      if (this.tourHubItem.bookingItinerary.itinerary[0].services.length) {
        this.startingPoint =
          this.tourHubItem.bookingItinerary.itinerary[0].services[0].place;
      } else if (
        this.tourHubItem.bookingItinerary.itinerary[0].moduleServices.length
      ) {
        this.startingPoint =
          this.tourHubItem.bookingItinerary.itinerary[0].moduleServices[0].place;
      }
    },
    getDuration() {
      this.duration = this.tourHubItem.bookingItinerary.numberOfDays;
    },
    getEndPoint() {
      const places =
        this.tourHubItem.bookingItinerary.itinerary[
          this.tourHubItem.bookingItinerary.itinerary.length - 1
        ].places;
      this.endPoint = places[places.length - 1] && places[places.length - 1].title ? places[places.length - 1].title :'';
    },
    getStatus() {
      this.status = this.tourHubItem.status ? this.tourHubItem.status : null;
    },
    getTourFor() {
      const travellers = this.tourHubItem.passengerInformation.travellers;
      this.tourFor = outputTravellers(travellers);
    },
    getStartDate() {
      const date = this.tourHubItem.bookingInformation.startDate;
      const formattedDate = dayjs(date).format("dddd, Do, MMMM");
      this.startDate = formattedDate;
    },
    getEndDate() {
      // Need to check if last service is accommodation - if so we need to add one day to the end date
      let finalServiceType;
      this.tourHubItem.bookingItinerary.itinerary.forEach((itineraryItem) => {
        const serviceEndIndex = itineraryItem.services.length - 1;
        if (serviceEndIndex >= 0) {
          finalServiceType =
            itineraryItem.services[serviceEndIndex].serviceType;
        }
      });
      const date = this.tourHubItem.bookingInformation.endDate;
      let formattedDate;
      if (finalServiceType === "Accommodation") {
        formattedDate = dayjs(date).add(1, "day").format("dddd, Do, MMMM");
      } else {
        formattedDate = dayjs(date).format("dddd, Do, MMMM");
      }
      this.endDate = formattedDate;
    },
    capitalise(text) {
      text = text.toLowerCase();
      let re = /(\b[a-z](?!\s))/g;
      let regexText = text.replace(re, (x) => x.toUpperCase());

      return regexText;
    },
    openLink(_link) {
      window.open(`https://www.trailfinders.${getSite()}${_link}`, "_blank");
    },
    handleVoucherModalOpen() {
      this.$refs.voucherModal.showModal();
    },
    toggleIsVisible(action, forceClose = false) {
      this.$root.$emit("toggleShowTouringItinerary", {
        id: this.tourHubItem._id,
        action,
      });
      if (forceClose) {
        this.showBlackButton = false;
      } else {
        this.showBlackButton = !this.showBlackButton;
      }
    },
    changeView() {
      const thId = this.tourHubItem._id;
      const uniqueRef = this.tourHubItem.bookingInformation.tfUniqueRef;
      this.$emit("toggle-th-show-all", {
        type: this.viewOptionSelected,
        thId,
        uniqueRef,
      });
    },
    specialOfferBookingDate(bookingValidity) {
      const { dateTo, type, daysBefore } = bookingValidity
      if (type === 'dateRange' && dayjs(dateTo).isValid()) {
        return `Book by ${dayjs(dateTo).format('DD MMM YY')}`
      } else if (type === 'daysBefore' && daysBefore) {
        const startDate = parseWithWeekday(this.item.groupdate, 'ddd DD MMM YYYY')
        if (startDate.isValid()) {
          let dateBy = startDate.subtract(daysBefore, 'days').format('DD MMM YY')
          return `Book By ${dateBy}`
        }
      }
      return ''
    },
    setReservationFor() {
      if (
        this.tourHubItem &&
        this.tourHubItem.passengerInformation &&
        this.tourHubItem.passengerInformation.travellers &&
        this.tourHubItem.passengerInformation.travellers.length
      ) {
        if (
          this.tourHubItem.passengerInformation.tourTravellers.length ===
          this.tourHubItem.passengerInformation.travellers.length
        ) {
          this.serviceTravellers = false;
        } else {
          this.serviceTravellers = outputTravellers(
            this.tourHubItem.passengerInformation.tourTravellers
          );
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../styles.scss";

.voucher-btn {
  background-color: #fcb134 !important;
}
.btn-dark {
  background-color: black !important;
}

@media only screen and (min-width: 994px) {
  .button-width {
    width: 502px !important;
  }
}

@media only screen and (max-width: 993px) {
  .button-width {
    width: 100%;
  }
}

@media only screen and (min-width: 994px) {
  .view-options-button-width {
    width: 302px !important;
  }
}

@media only screen and (max-width: 993px) {
  .view-options-button-width {
    width: 100%;
  }
}

.btn-info {
  position: relative;
  i {
    left: 10px;
  }
  span {
    width: 100%;
    justify-content: center;
  }
}

@media only screen and (min-width: 994px) {
  .button-width {
    width: 502px !important;
  }
}

@media only screen and (max-width: 993px) {
  .button-width {
    width: 100%;
  }
}
</style>

<style scoped>
.itinerary-pending-notice {
  background-color: #fff8e6 !important;
  border: 1.5px solid #f0b429 !important;
  color: #7d5a00 !important;
  cursor: not-allowed !important;
  opacity: 0.9;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.82rem;
}

@media only screen and (min-width: 994px) {
  .itinerary-pending-notice {
    white-space: nowrap;
  }
}

.custom-select {
  background: black
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='lightgray' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
  color: lightgray;
}
@media (max-width: 934px) {
  .extra-info-alt button {
    margin-bottom: 0px !important;
  }
}
</style>
